'use client';

import { type HTMLMotionProps, motion } from 'framer-motion';

/**
 * Server-safe Motion.div component.
 *
 * This component uses the Donut pattern to ensure compatibility when rendered in a server component.
 */

export const MotionDiv = ({ children, ...props }: HTMLMotionProps<'div'>) => (
  <motion.div {...props}>{children}</motion.div>
);
